function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".pt-flag_svg__st0{fill:#e91d26}.pt-flag_svg__st2{fill:#f4eb32}.pt-flag_svg__st3{fill:#010101}.pt-flag_svg__st4{fill:none}.pt-flag_svg__st5{fill:#fff}.pt-flag_svg__st6{fill:#2d2d86}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st0",
  d: "M179.1 106.7H512v298.7H179.1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2e6934",
  d: "M0 106.7h179.1v298.7H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M237.4 302.3c-22.5-.7-125.9-65.2-126.6-75.5l5.7-9.5c10.3 14.9 115.9 77.7 126.3 75.5l-5.4 9.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M115.3 216c-2 5.4 27 23.4 61.9 44.6 34.9 21.2 65 34.3 67.2 32.5.1-.3 1.1-1.9 1-1.9-.4.6-1.4.8-3 .4-9.4-2.7-34-14-64.4-32.5-30.4-18.5-56.9-35.5-61-42.7-.3-.5-.5-1.4-.5-2.1h-.1l-.9 1.5-.2.2zM238 302.6c-.4.7-1.1.7-2.4.6-8.4-.9-34-13.4-64.3-31.5-35.2-21.1-64.3-40.3-61.2-45.4l.9-1.5h.2c-2.8 8.5 57.4 43 61 45.2 34.9 21.6 64.3 34.2 66.9 31l-1.1 1.6z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M236.6 303.5c-.3 0-.7 0-1.1-.1-8.6-1-34.5-13.6-64.4-31.6-40-24-60.1-38.4-61.4-44.1-.1-.6-.1-1.2.2-1.6l.8-1.5v.5l-.5 1.2c-.2.3-.3.8-.1 1.3 1.3 5.6 21.4 19.9 61.2 43.8 29.9 17.9 55.7 30.5 64.2 31.5 1.3.1 1.9.1 2.2-.5l.6-1c-.3.1-.7.2-1.1.2-7.1 0-33.5-11.8-65.3-31.5-.3-.2-1.2-.7-2.4-1.4-38.9-23-58.7-37.5-58.8-43.3.8 3.8 9.9 14 59 42.9 1.2.7 2.1 1.2 2.4 1.4 31.7 19.7 58 31.4 65 31.4.8 0 1.3-.2 1.5-.4v.1c0 .2 0 .3-.1.4l-.4 1.4c-.3.8-.9.9-1.5.9zm7-10c-5.2 0-33.8-12.7-66.6-32.7-37.5-22.9-64-39.5-61.9-44.9l1-1.8s0 .1.1.1l-.6 1.6c-2.2 5.7 31.7 26.4 61.7 44.6 32.7 19.9 61.1 32.6 66.3 32.6.4 0 .6-.1.6-.1.2-.4.4-.7.6-1.1-.5.2-1.4.2-2.5-.1-10.3-3-35.8-15.1-64.5-32.5-27.8-16.9-56.7-35.1-61.1-42.8-.3-.5-.5-1.5-.5-2.2.4.7.6 1.6.9 2 4.3 7.7 34.9 26.8 61 42.7 28.7 17.4 54.1 29.5 64.4 32.5 1.4.4 2.4.3 2.8-.3.5.2.5.2-.4 1.7-.6.6-.8.7-1.3.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M179.2 233c22.6-.2 50.4-3.1 66.4-9.5l-3.5-5.6c-9.5 5.2-37.5 8.7-63.2 9.2-30.4-.3-51.8-3.1-62.6-10.3l-3.3 6c19.9 8.4 40.1 10.1 66.2 10.2z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M246.5 223.7c-.6.9-11 4.5-26.4 7.1-10.4 1.6-24.1 3-41 3-16.1 0-29.3-1.1-39.3-2.5-16.2-2.5-24.5-6.1-27.6-7.3.3-.6.5-1 .8-1.5 8.9 3.5 17.3 5.7 27.1 7.2 9.9 1.3 23 2.5 39 2.5 16.9 0 30.4-1.5 40.7-3 15.8-2.5 24.4-5.8 25.6-7.4l1.1 1.9zm-3-5.7c-1.7 1.4-10.2 4.4-25.2 6.8-10 1.4-22.7 2.7-39 2.7-15.4 0-28.1-1-37.7-2.4-15.2-2-23.3-5.6-26.3-6.6l.9-1.5c2.3 1.1 10.1 4.3 25.5 6.5 9.5 1.3 22.1 2.3 37.5 2.3 16.2 0 28.8-1.3 38.7-2.8 15.1-2.1 23.2-5.9 24.4-6.9l1.2 1.9z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M178.6 234c-13.6 0-26.7-.8-38.8-2.5-15.7-2.5-24.2-5.9-27.3-7.2l-.1-1 .5-1c8.8 3.3 17.1 5.5 27.3 7.1 12.2 1.7 25.2 2.5 38.7 2.5 14 0 27.4-1 41-3 15.6-2.5 24.3-5.8 25.5-7.3l1.5 2c-.6 1.2-11.5 4.9-26.5 7.5-12.8 2-26.6 3-41.1 3h-.7v-.1zm-65.7-11.3l-.5 1.4c3.3 1.1 11.8 4.5 27.4 7 12.1 1.6 25.2 2.5 38.8 2.5v.2l.5-.2c14.4 0 28.2-1 41-3 15.8-2.7 25.8-6.3 26.2-7l-1.1-1.7c-.8 1.5-8.8 4.8-25.4 7.5-13.6 2-27 3-40.8 3-13.8 0-26.8-.8-39-2.5-10.2-1.6-18.6-3.9-27.1-7.2zm66.1 5c-13.6 0-26.6-.8-37.4-2.4-13.5-1.8-21.3-4.7-25.1-6.2l-1.2-.5.5-1.4c.1-.1.4-.5.5-.5 1.3.7 8.8 4.1 25.5 6.5 7.5 1.1 20 2.3 37.2 2.3 13.7 0 26-.9 39-2.8 14.4-2 22.9-5.7 24.3-6.9l1.4 1.9c-1.7 1.6-10.1 4.7-25.4 7.1-13 1.9-25.4 2.7-39 2.7 0 .2-.3.2-.3.2zm-62.8-10.5l-.6 1.4 1.1.2c3.7 1.4 11.5 4.4 25 6.1 10.8 1.6 23.7 2.4 37.4 2.4v.2l.3-.2c13.6 0 26-.9 39-2.7 15.2-2.4 23.5-5.4 25.1-6.8l-1.1-1.6c-.8.9-8.6 4.9-24.2 7-13 1.9-25.3 2.7-38.7 2.8-17.5 0-30-1.3-37.5-2.3-16.9-2.4-24.5-5.9-25.8-6.5z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M105.1 260.2c13.9 7.5 44.7 11.2 73.9 11.5 26.6 0 61.2-4.1 74.1-11l-.4-7.5c-4 6.3-41.1 12.4-74 12.2-32.9-.2-63.5-5.3-73.6-11.9v6.7z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M253.8 259.2v1.8c-1.9 2.3-14.1 5.8-29.4 8.3-11.6 1.8-26.8 3.1-45.7 3.1-18 0-32.3-1.3-43.4-3-17.6-2.6-28.8-7-31-8.4v-2.1c6.8 4.5 25.1 7.8 31.3 8.8 11 1.7 25.3 3 43.1 3 18.8 0 33.9-1.3 45.5-3.1 10.9-1.6 26.5-5.7 29.6-8.4zm0-6.4v1.8c-1.9 2.3-14.1 5.8-29.4 8.3-11.6 1.8-26.8 3.1-45.7 3.1-18 0-32.3-1.3-43.4-3-17.6-2.6-28.8-7-31-8.4v-2.1c6.8 4.5 25.1 7.8 31.3 8.8 11 1.7 25.3 3 43.1 3 18.8 0 33.9-1.3 45.5-3.1 10.9-1.5 26.5-5.6 29.6-8.4z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M178.6 272.6c-15.9 0-30.5-1-43.4-3-16.8-2.4-28.4-6.8-31.1-8.4l-.1-2.3c7.1 4.3 25.9 7.7 31.5 8.6 12.8 2 27.3 3 43.1 3 16.7 0 32-1 45.4-3.1 10.9-1.6 26.5-5.7 29.6-8.4l.4 2c-2.1 2.6-14.5 6.1-29.6 8.5-13.6 2-29 3.1-45.8 3.1zm-74.5-13.5l.3 1.9c1.6.8 12.5 5.5 30.9 8.2 12.9 2 27.5 3 43.4 3 16.8 0 32.1-1.1 45.7-3.1 14.8-2.4 27.4-5.9 29.3-8.2l-.1-1.7c-2.7 2.9-18.5 7.1-29.4 8.7-13.5 2.1-28.8 3.1-45.5 3.1-15.9 0-30.4-1-43.2-3-7.2-1.2-24.7-4.4-31.4-8.9zm74.5 7.2c-15.9 0-30.5-1-43.4-3-16.9-2.5-28.4-6.8-31.1-8.4l-.1-2.3c7.1 4.3 25.9 7.7 31.5 8.6 12.8 2 27.3 3 43.1 3 16.7 0 32-1 45.4-3.1 10.9-1.6 26.5-5.7 29.6-8.4l.4 1.9c-2.1 2.6-14.5 6.1-29.6 8.5-13.6 2.1-28.9 3.2-45.8 3.2zm-74.5-13.5l.3 1.9c1.6.8 12.4 5.5 30.9 8.2 12.9 2 27.5 3 43.4 3 16.8 0 32.2-1.1 45.7-3.1 14.8-2.4 27.4-5.9 29.3-8.2l-.1-1.6c-2.8 2.9-18.5 7.1-29.4 8.7-13.4 2.1-28.7 3.1-45.5 3.1-15.8 0-30.3-1-43.2-3-7.2-1.4-24.7-4.6-31.4-9z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M178.9 301.1c-31.9-.2-59.3-8.7-65-10.1l4.2 6.6c10.2 4.3 36.9 10.7 61.1 10 24.2-.7 45.4-2.6 60.4-9.9l4.3-6.8c-10.2 4.7-44.8 10.1-65 10.2z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M241.2 296.1c-.6 1-1.3 1.9-1.9 2.9-7 2.5-18.2 5.1-22.8 5.9-9.6 2-24.4 3.4-37.5 3.4-28.3-.4-51.4-6-62.3-10.7l-.9-1.5.1-.2 1.5.6c19.4 6.9 41.1 9.7 61.7 10.2 13.1 0 26.2-1.5 36.8-3.4 16.2-3.3 22.8-5.7 24.8-6.8l.5-.4zm3.8-6.2c0 .1 0 .1 0 0-.4.9-.9 1.7-1.4 2.5-3.8 1.3-14 4.3-28.9 6.4-9.8 1.3-15.9 2.6-35.4 3-36.6-.9-60.3-8.1-65.9-9.8l-.8-1.6c21.2 5.5 42.8 9.4 66.7 9.8 17.9-.4 25.4-1.7 35.2-3 17.4-2.7 26.1-5.6 28.7-6.4 0 0-.1-.1-.1-.2l1.9-.7z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M178.9 308.5c-28.8-.4-51.6-6-62.4-10.7l-1-1.6c0-.1.3-.5.4-.5l1.5.6c17.3 6.2 38 9.6 61.6 10.2 14.8 0 28.1-1.8 36.7-3.4 18.1-3.6 23.5-6.1 24.8-6.8.1 0 .2-.1.4-.1 0 0 0-.1.1-.1l.2.1c.1 0 .2 0 .2.1-.6 1-1.3 1.9-1.9 2.9-7.1 2.5-18.1 5.1-23 5.9-10.1 2-24.8 3.4-37.6 3.4zM115.8 296l1 1.4c11.5 4.9 35.2 10.2 62.1 10.6 12.5 0 27.5-1.4 37.5-3.4 4.9-.8 15.9-3.4 22.8-5.8.4-.7.9-1.4 1.4-2.1-1.6.8-7.4 3.3-24.7 6.7-8.7 1.6-22 3.4-36.2 3.4-24.3-.6-45-4-62.4-10.2l-1.5-.6zm63.5 6.1c-32.5-.8-55.3-6.5-65.9-9.9l-1-1.7c24.5 6 45.7 9.1 66.9 9.5 15.8-.3 23.7-1.4 32-2.6l3.2-.4c16.6-2.6 25.5-5.4 28.4-6.3l2.1-1-.1.2-1.7.9c-3.1 1.2-12 4-28.7 6.5l-3.2.4c-8.3 1.2-16.1 2.2-32 2.6-21.3-.4-42.5-3.5-66.8-9.8l1.1 1.3c10.5 3.2 33.2 8.9 65.7 9.7 16.6-.3 23.4-1.3 31.2-2.4l4.2-.6c13.2-1.9 23.8-4.6 28.8-6.4l1.3-2.3-1.1 2.6c-5.1 1.9-15.7 4.7-29 6.5l-4.2.6c-7.8 1.3-14.6 2.2-31.2 2.6z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M178.9 189.6c36.6 0 66.2 29.8 66.2 66.5s-29.6 66.3-66.2 66.3-66.3-29.7-66.3-66.4 29.7-66.4 66.3-66.4zm0-6.6c40.2 0 72.9 32.8 72.9 73s-32.7 73-72.9 73-72.9-32.8-72.9-73 32.8-73 72.9-73z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M179 182.1c40.7 0 73.9 33.2 73.9 73.9s-33.2 74-73.9 74-73.9-33.2-73.9-74c0-40.6 33.2-73.9 73.9-73.9zm0 1.7c39.6 0 72.3 32.5 72.3 72.3s-32.6 72.3-72.3 72.3c-39.6 0-72.3-32.5-72.3-72.3s32.7-72.3 72.3-72.3z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M179 330.2c-40.9 0-74.1-33.3-74.1-74.2 0-40.9 33.2-74.2 74.1-74.2 40.9 0 74.1 33.3 74.1 74.2 0 41-33.3 74.2-74.1 74.2zm0-147.9c-40.6 0-73.7 33.1-73.7 73.7 0 40.7 33 73.7 73.7 73.7 40.6 0 73.7-33.1 73.7-73.7s-33.1-73.7-73.7-73.7zm0 146.3c-40 0-72.5-32.5-72.5-72.5s32.5-72.5 72.5-72.5 72.5 32.5 72.5 72.5-32.6 72.5-72.5 72.5zm0-144.6c-39.7 0-72 32.3-72 72.1s32.3 72.1 72 72.1 72-32.3 72-72.1-32.3-72.1-72-72.1z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M179.1 188.3c37.1 0 67.7 30.5 67.7 67.7s-30.6 67.7-67.7 67.7-67.7-30.5-67.7-67.7 30.6-67.7 67.7-67.7zm0 1.6c36.2 0 66 29.7 66 66.1 0 36.4-29.8 66.1-66 66.1s-66-29.7-66-66.1c-.1-36.3 29.7-66.1 66-66.1z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M179.1 324c-37.4 0-67.9-30.5-67.9-68s30.5-68 67.9-68c37.4 0 67.9 30.5 67.9 68s-30.5 68-67.9 68zm0-135.5c-37.2 0-67.5 30.3-67.5 67.5s30.3 67.5 67.5 67.5 67.4-30.3 67.4-67.5-30.2-67.5-67.4-67.5zm0 133.8c-36.5 0-66.3-29.7-66.3-66.3 0-36.6 29.7-66.3 66.3-66.3 36.5 0 66.3 29.7 66.3 66.3-.1 36.6-29.8 66.3-66.3 66.3zm0-132.2c-36.3 0-65.8 29.6-65.8 65.9 0 36.3 29.5 65.9 65.8 65.9s65.8-29.6 65.8-65.9c0-36.3-29.5-65.9-65.8-65.9z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M176 181.8h6.4v148.8H176z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st4",
  d: "M176.8 181.8h4.5-4.5zM176.9 330.4h4.5-4.5z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M181.4 181h1.6v150.3h-1.6V181zm-6.3 0h1.6v150.3h-1.6V181z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M183 331.5h-1.6l-.2-150.5 1.8-.2.2 150.5c0 .1 0 .1-.1.2h-.1zm-.2-150.5l-1.4.2.2 150.1 1.2-.2V181zm-6.1 150.5h-1.6l-.2-150.5 1.8-.2.2 150.5c0 .1 0 .1-.1.2h-.1zm-.2-150.5l-1.4.2.2 150.1 1.2-.2V181z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M104.9 252.9c9.3-8.5 43.4-14.1 73.8-13.9 30.3.1 66.2 6.4 74 13.8l.1 6.4c-6.5-6.2-34.4-13.5-74.1-13.6-39.6-.1-68.4 7.5-73.8 13.8v-6.5z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M105.1 258.7l-.4-5.5c0-.2.4-.2.4 0v5.5zM253.1 258.9l-.4-5.5c0-.2.4-.2.4 0v5.5z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M179 244.6c17.4 0 34.4 1.7 47.8 4.3 13.9 2.8 23.6 6.2 26.9 10.1v1.9c-4-4.8-17.1-8.4-27.3-10.4-13.3-2.6-30.1-4.3-47.5-4.2-18.3 0-35.4 1.8-48.5 4.3-10.5 2.1-24.6 6.3-26.3 10.4v-2c1-2.8 11.4-7.1 26.1-10 13.3-2.6 30.4-4.3 48.8-4.4zm0-6.3c17.4 0 34.4 1.6 47.8 4.3 13.8 2.8 23.6 6.2 26.9 10.1v1.9c-4-4.8-17.1-8.4-27.2-10.4-13.3-2.6-30.1-4.3-47.5-4.2-18.3 0-35.3 1.8-48.4 4.3-10.2 1.9-24.8 6.3-26.4 10.3v-2c1-2.8 11.6-7.2 26.1-10 13.2-2.6 30.3-4.3 48.7-4.3z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M104.2 261.2c-.1 0-.2-.1-.2-.2v-2c1-3.1 12.1-7.4 26.3-10.2 14.1-2.8 31.4-4.3 48.8-4.3 16.8 0 33.7 1.5 47.8 4.3 14.5 2.9 23.8 6.4 27.1 10.2l.1 2.1c-4.6-5-19.2-8.6-27.5-10.2-14-2.7-30.6-4.2-46.9-4.2-17.7 0-34.9 1.6-49 4.3-11.5 2.3-24.6 6.5-26.2 10.2-.1-.1-.2 0-.3 0zm74.8-15.1c16.8 0 33.5 1.5 47.5 4.2 8.4 1.7 23 5.3 27.4 10.5l-.4-1.8c-3.1-3.6-12.4-7-26.8-9.9-14.2-2.8-31-4.3-47.4-4.3-17.7 0-34.9 1.6-49 4.3-15.7 3.1-25.1 7.4-25.9 9.9v1.2c3.1-4.2 17.6-8.1 26.1-9.8 14.2-2.7 31.4-4.3 48.5-4.3zm-74.8 8.8c-.1 0-.2-.1-.2-.2v-2c1.1-3.1 12.4-7.5 26.3-10.2 14.1-2.8 31.4-4.3 48.8-4.3 16.9 0 33.7 1.5 47.8 4.3 14.5 2.9 23.8 6.4 27.1 10.2v2.1c-4.6-5-19.2-8.5-27.5-10.2-14-2.7-30.7-4.2-47.1-4.2-17.4 0-34.6 1.6-48.7 4.3-11.6 2.2-24.8 6.5-26.3 10.2 0-.1-.1 0-.2 0zm74.8-15.2c16.7 0 33.5 1.5 47.5 4.2 8.4 1.7 23 5.3 27.4 10.5l-.4-1.8c-3.1-3.6-12.4-7-26.8-9.9-14.1-2.8-30.9-4.3-47.2-4.3-17.9 0-35.2 1.6-49.2 4.3-15.1 3-25.1 7.3-25.9 9.9v1.2c3-4.1 17-8 26.2-9.8 14.2-2.7 31.4-4.2 48.4-4.3z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M178.7 205.9c27.5-.1 51.5 3.8 62.4 9.5l4 6.9c-9.5-5.1-35.4-10.5-66.4-9.7-25.3.2-52.2 2.8-65.8 10l4.8-8c11.1-5.7 37.3-8.6 61-8.7z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st4",
  d: "M241.8 216.5l2.7 4.4-2.7-4.4z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M179 211.7c15.7 0 30.8.8 42.9 3 11.2 2.1 21.9 5.2 23.5 6.9l1.2 2.1c-3.7-2.4-13-5.1-24.9-7.4-11.9-2.2-27.1-3-42.7-2.9-17.7-.1-31.4.9-43.2 2.9-12.5 2.3-21.1 5.7-23.3 7.3l1.2-2.2c4.1-2.1 10.7-4.7 21.8-6.7 12.2-2.3 26.1-2.9 43.5-3zm0-6.4c15 0 29.8.8 41.4 2.9 9.1 1.8 18.1 4.5 21.4 7l1.7 2.8c-3-3.3-14.1-6.4-23.9-8.1-11.5-2-25.7-2.8-40.7-2.9-15.7 0-30.3 1-41.6 3.1-10.8 2.1-17.7 4.5-20.7 6.4l1.5-2.3c4.1-2.1 10.6-4.1 18.9-5.7 11.5-2.2 26.2-3.1 42-3.2z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M246.6 223.9h-.1c-3.6-2.4-12.7-5.1-24.8-7.4-10.4-2-24.3-2.9-41.2-2.9h-3c-17 0-30.2.9-41.6 2.9-12.4 2.3-21 5.6-23.2 7.2l.8-2.5c5.7-2.9 12.9-5.1 22-6.8 11.1-2 23.7-2.9 43.6-3h.9c16.5 0 31 1.1 42 3 11.4 2.1 22 5.3 23.6 7l1.2 2.1v.3c-.1.1-.2.1-.2.1zm-66.6-12h-1c-19.9.1-32.5 1-43.6 3-9.1 1.6-16.2 3.8-21.7 6.6l-1.1 2.1c1.9-1.9 10.5-5.2 23-7.6 11.4-2 24.7-2.9 41.7-2.9h3c17 0 30.9 1 41.3 3 11.4 2.2 20.2 4.7 24.2 7l-.8-1.4c-1.4-1.6-12.1-4.7-23.3-6.8-10.8-2-25.3-3-41.7-3zm63.6 6.3c-.1 0-.1 0-.2-.1-3-3.4-14.7-6.5-23.7-8.1-10.4-1.8-23.7-2.7-40.6-2.9-16.4 0-30.8 1.1-41.6 3.1-9.6 1.8-17.3 4.2-20.6 6.4l1.2-2.6c4.1-2.2 10.7-4.2 19-5.8 10.7-2 25.2-3 41.9-3.1h1.2c15.8 0 29.7 1 40.2 2.9 9.8 1.9 18.4 4.7 21.5 7l1.8 2.8c.1.1 0 .2 0 .3 0 .1-.1.1-.1.1zM179 206.7c17 .1 30.3 1.1 40.7 2.9 8.2 1.5 18.6 4.2 22.9 7.2l-1-1.5c-3-2.2-11.6-5-21.3-6.9-10.4-1.9-24.3-2.9-40.1-2.9H179c-16.7 0-31.1 1.1-41.8 3.1-8.3 1.6-14.8 3.6-18.8 5.7l-1.4 2.2c3.1-2.5 10.8-4.9 20.4-6.7 10.8-2 25.2-3 41.6-3.1z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M215.7 286.8c-13.6-2.5-27.2-2.9-36.7-2.8-45.8.5-60.6 9.4-62.4 12.1l-3.4-5.6c11.7-8.5 36.6-13.2 66.1-12.7 15.3.3 28.5 1.3 39.6 3.4l-3.2 5.6z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st4",
  d: "M113.9 291.3l2.2 3.9-2.2-3.9z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M178.8 283.2c12.7.2 25.3.7 37.3 3l-.9 1.6c-11.2-2.1-23.2-2.9-36.4-2.8-16.9-.1-34 1.4-48.9 5.7-4.7 1.3-12.5 4.3-13.3 6.8l-.9-1.4c.3-1.5 5-4.5 13.7-7 17.1-4.9 33.1-5.8 49.4-5.9zm.5-6.4c13.2.3 26.8.9 40.1 3.5l-.9 1.6c-12-2.4-23.4-3.2-39.1-3.4-17 0-35 1.2-51.3 6-5.3 1.5-14.4 4.9-14.7 7.5l-.9-1.5c.2-2.4 8.1-5.5 15.2-7.6 16.5-4.8 34.5-6.1 51.6-6.1z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M116.6 297.7c-.1 0-.1 0-.2-.1l-.9-1.4c.3-1.8 5.2-4.9 13.9-7.3 16.3-4.7 31.5-5.7 49.3-5.8 12.1.2 25 .7 37.4 3l-.7 1.9c-10.4-1.8-21.7-2.7-35-2.7h-3.5c-17.9 0-33.7 1.9-46.9 5.7-5 1.4-12.4 4.4-13.1 6.7-.1-.1-.2 0-.3 0zm62.1-14.3c-17.8.1-32.9 1.2-49.2 5.8-8.9 2.5-13.4 5.6-13.6 6.8l.6 1c1.5-2.8 10-5.7 13.3-6.6 13.2-3.8 29.1-5.7 47-5.7h3.5c13.2 0 24.6.9 34.8 2.8l.7-1.5c-12.1-1.9-25-2.4-37.1-2.6zm-65.3 8.8c-.1 0-.1 0-.2-.1l-.9-1.5c.2-3.3 11.8-6.9 15.3-7.9 14.1-4.1 30.5-6 51.7-6.1 13 .2 26.8.8 40.1 3.5l-.8 1.9c-12.9-2.4-25-3.1-39.3-3.3-21 0-37.3 1.9-51.3 6-6.8 2-14.3 5.1-14.6 7.3.2.1.1.2 0 .2zm65.9-15.2c-21.1 0-37.5 2-51.6 6.1-9 2.6-14.9 5.5-15 7.4l.6 1c1.5-3.2 13.3-6.8 14.7-7.2 14-4.1 30.3-6 51.4-6 14.3.2 26.4.9 39.1 3.4l.7-1.5c-13.1-2.3-26.9-2.9-39.9-3.2z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M165.6 281.3c0-.2.1-.4.2-.6.1-.1.3-.2.5-.2.1 0 .2 0 .3.1.1.1.2.1.2.2s.1.2 0 .4c0 .1 0 .3-.1.4l-.3.3c-.1.1-.2.1-.3.1-.1 0-.2 0-.3-.1-.1-.1-.2-.1-.2-.2v-.4zm.2 0c0 .2 0 .3.1.4.1.1.2.1.3.1.1 0 .3-.1.3-.2.1-.1.2-.2.2-.4v-.3c0-.1-.1-.1-.1-.2h-.2c-.1 0-.2.1-.3.2-.2 0-.2.2-.3.4zm1.8.2h.2c0 .1 0 .1.1.2h.2c.1 0 .1 0 .2-.1l.1-.1v-.1h-.2c-.1 0-.2 0-.3-.1l-.1-.1v-.1-.1s0-.1.1-.1h.4s.1 0 .1.1v.1h-.2v-.1H167.9s0 .1-.1.1v.1h.2c.1 0 .2 0 .2.1 0 0 .1 0 .1.1v.1c0 .1 0 .1-.1.2 0 0-.1.1-.2.1h-.2c-.1 0-.2 0-.3-.1.1 0 .1-.1.1-.2zm1.7-.1h.2c0 .1-.1.2-.2.2-.1.1-.2.1-.3.1-.1 0-.3 0-.3-.1-.1-.1-.1-.2-.1-.4s.1-.3.2-.4c.1-.1.2-.1.3-.2.1 0 .2 0 .3.1.1.1.1.2.1.4h-.7c0 .1 0 .2.1.2 0 .1.1.1.2.1h.2c-.1.1-.1 0 0 0zm-.5-.3h.5v-.2c0-.1-.1-.1-.2-.1s-.1 0-.2.1-.1.1-.1.2zm.8.6h.2v.1h.4l.1-.1v-.2c-.1.1-.2.1-.3.1-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.3 0-.1 0-.2.1-.3 0-.1.1-.1.2-.2.1 0 .1-.1.2-.1s.2 0 .3.1v-.1h.1l-.1.9c0 .2 0 .3-.1.3 0 .1-.1.1-.2.2-.1 0-.2.1-.3.1-.1 0-.2 0-.3-.1.1-.1 0-.2.1-.3zm.2-.6v.3c0 .1.1.1.2.1s.1 0 .2-.1.1-.2.1-.3v-.3c0-.1-.1-.1-.2-.1s-.1 0-.2.1-.1.2-.1.3zm.8.5l.1-1h.2v.1c0-.1.1-.1.1-.1.1 0 .1-.1.2-.1h.2l.1.1c.1-.1.2-.2.3-.2.1 0 .2 0 .2.1v.3l-.1.7h-.2l.1-.6v-.1-.1h-.1c-.1 0-.2 0-.2.1 0 0-.1.1-.1.2l-.1.6h-.2l.1-.6v-.2s-.1-.1-.1 0h-.1l-.1.1v.2l-.1.5h-.2zm2.3-.4h.2c0 .1-.1.2-.2.2-.1.1-.2.1-.3.1-.1 0-.3 0-.3-.1-.1-.1-.1-.2-.1-.4s.1-.3.2-.4c.1-.1.2-.1.3-.2.1 0 .2 0 .3.1.1.1.1.2.1.4h-.7c0 .1 0 .2.1.3 0 .1.1.1.2.1h.2c-.1 0 0 0 0-.1zm-.5-.3h.5v-.2c0-.1-.1-.1-.2-.1s-.1 0-.2.1c0 .1-.1.1-.1.2zm.8.6l.1-1h.2v.1c.1-.1.2-.2.3-.2h.2s.1 0 .1.1V280.8l-.1.6h-.2l.1-.6v-.2l-.1-.1h-.1c-.1 0-.1 0-.2.1s-.1.1-.1.3l-.1.5-.1.1zm1.5-.2v.1h-.2l-.1-.1v-.2l.1-.6h-.1v-.1h.1v-.3l.2-.1v.3h.2v.1h-.2l-.1.6v.1c0 .2 0 .2.1.2zm.1-.4c0-.2.1-.3.2-.4.1-.1.2-.1.3-.1.1 0 .2 0 .3.1.1.1.1.2.1.4 0 .1 0 .2-.1.3 0 .1-.1.1-.2.2-.1 0-.2.1-.2.1-.1 0-.2 0-.3-.1-.1-.2-.1-.3-.1-.5zm.2 0v.3c0 .1.1.1.2.1s.2 0 .2-.1c.1-.1.1-.2.1-.3v-.3c0-.1-.1-.1-.2-.1s-.2 0-.2.1-.1.2-.1.3zm2.1.2h.2c0 .1-.1.2-.2.2-.1.1-.2.1-.3.1-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.4s.1-.3.2-.4c.1-.1.2-.1.3-.1.1 0 .2 0 .3.1.1.1.1.2.1.4h-.7v.3c0 .1.1.1.2.1h.2c0-.1 0-.1.1-.2zm-.5-.3h.5v-.2c0-.1-.1-.1-.2-.1s-.1 0-.2.1-.1.1-.1.2zm.8.6l.2-1.4h.2l-.2 1.4h-.2zm.6-1.2v-.2h.2v.2h-.2zm-.2 1.2l.2-1h.2l-.2 1h-.2zm.4 0l.2-1h.1v.1l.1-.1h.4l.1.1c.1-.1.2-.2.3-.2.1 0 .2 0 .2.1s.1.1 0 .3l-.1.7h-.2l.1-.6v-.1-.1h-.1c-.1 0-.1 0-.2.1-.1 0-.1.1-.1.2l-.1.6h-.2l.1-.6v-.2l-.1-.1h-.1l-.1.1s0 .1-.1.2l-.1.5h-.1zm1.8-1.2v-.2h.2v.2h-.2zm-.2 1.2l.2-1h.2l-.2 1h-.2zm.4 0l.2-1h.1v.1c.1-.1.2-.2.3-.2h.2s.1 0 .1.1V280.7l-.1.6h-.2l.1-.6v-.2-.1h-.1c-.1 0-.2 0-.2.1-.1 0-.1.1-.1.3l-.1.5h-.2v.1zm1.7-.1c-.1.1-.1.1-.2.1h-.2c-.1 0-.2 0-.2-.1s-.1-.1 0-.2v-.1l.1-.1h.5v-.1s-.1-.1-.2-.1h-.2l-.1.1h-.2c0-.1.1-.1.1-.2 0 0 .1-.1.2-.1h.4s.1 0 .1.1v.9h-.2c.1-.1.1-.2.1-.2zm0-.4c-.1 0-.2 0-.3.1h-.1s-.1 0-.1.1v.2H181.7l.1-.1c.1-.1.1-.2.1-.3zm1 .5v-.1c-.1.1-.2.2-.3.1-.1 0-.1 0-.2-.1-.1 0-.1-.1-.1-.2v-.3c0-.1.1-.2.1-.3 0-.1.1-.1.2-.2.1 0 .1-.1.2-.1h.1l.1.1.1-.5h.2l-.3 1.4h-.1v.2zm-.5-.5v.3c0 .1.1.1.2.1s.1 0 .2-.1.1-.2.1-.3v-.3c0-.1-.1-.1-.2-.1s-.1 0-.2.1c0 .1 0 .2-.1.3zm.9 0c0-.2.1-.3.2-.4.1-.1.2-.1.3-.1.1 0 .2 0 .3.1.1.1.1.2.1.4 0 .1-.1.2-.1.3 0 .1-.1.1-.2.2-.1 0-.2.1-.2.1-.1 0-.2-.1-.3-.1-.1-.2-.1-.3-.1-.5zm.2 0v.3c0 .1.1.1.2.1s.2 0 .2-.1c.1-.1.1-.2.1-.3v-.3c0-.1-.1-.1-.2-.1s-.2 0-.2.1c-.1.1-.1.2-.1.3zm1.3.6l.2-1h.1v.2c0-.1.1-.1.1-.1h.1c.1 0 .1 0 .2.1l-.1.2h-.2s-.1 0-.1.1 0 .1-.1.2l-.1.5h-.1v-.2zm1.4-.3h.2c0 .1-.1.2-.2.2-.1.1-.2.1-.3.1-.1 0-.3-.1-.3-.2-.1-.1-.1-.2 0-.4 0-.2.1-.3.2-.4.1-.1.2-.1.3-.1.1 0 .2 0 .3.1.1.1.1.2 0 .4h-.7v.3c0 .1.1.1.2.1h.2s0-.1.1-.1zm-.5-.3h.5v-.2c0-.1-.1-.1-.2-.1s-.1 0-.2.1c0 0-.1.1-.1.2zm.8.3h.2v.2s.1 0 .2.1h.2l.1-.1v-.1s-.1 0-.2-.1c-.1 0-.2-.1-.2-.1l-.1-.1v-.1s0-.1.1-.1l.1-.1h.4c.1 0 .1.1.1.1v.2h-.2v-.1H186.9s-.1 0-.1.1v.1h.2c.1 0 .2.1.2.1l.1.1v.1c0 .1 0 .1-.1.2 0 0-.1.1-.2.1h-.2c-.1 0-.2 0-.3-.1v-.4zm.8.7l.3-1.4h.1v.1l.1-.1h.2c.1 0 .1 0 .2.1 0 0 .1.1.1.2v.3c0 .1-.1.2-.1.3 0 .1-.1.1-.2.2-.1 0-.2.1-.2.1h-.1l-.1-.1-.1.5h-.2v-.2zm.3-.9v.3c0 .1.1.1.2.1s.1 0 .2-.1.1-.2.1-.3v-.3c0-.1-.1-.1-.2-.1s-.1 0-.2.1c0 .1 0 .2-.1.3zm1.6.3h.2c0 .1-.1.2-.2.2s-.2.1-.3.1c-.1 0-.3-.1-.3-.1-.1-.1-.1-.2 0-.4 0-.2.1-.3.2-.4.1-.1.2-.1.3-.1.1 0 .2.1.3.2.1.1.1.2 0 .4h-.7v.3c0 .1.1.1.2.1h.2c0-.2 0-.3.1-.3zm-.5-.3h.5v-.2c0-.1-.1-.1-.2-.1s-.1 0-.2.1c-.1 0-.1.1-.1.2zm1-.6v-.2h.2v.2h-.2zm-.2 1.2l.2-1h.2l-.2 1h-.2zm.7-.1v.2H189.9v-.1-.2l.1-.6h-.1v-.1h.1v-.3l.2-.1-.1.3h.2v.1h-.2l-.1.6v.1c.1.1.2.1.2.1zm.8 0c-.1 0-.1.1-.2.1h-.2c-.1 0-.2 0-.2-.1s-.1-.1 0-.2c0 0 0-.1.1-.1l.1-.1s.1 0 .1-.1h.4v-.1s-.1-.1-.2-.1h-.2l-.1.1h-.2c0-.1.1-.1.1-.2 0 0 .1-.1.2-.1h.4s.1 0 .1.1v.9h-.2v-.1zm.1-.3h-.4-.1v.2H190.9c.1 0 .1-.1.1-.1 0 .1 0 0 .1-.1zm.8 0c0-.2.1-.3.2-.4.1-.1.2-.1.3-.1.1 0 .2 0 .3.1.1.1.1.2 0 .4 0 .1-.1.2-.1.3 0 .1-.1.1-.2.2h-.2c-.1 0-.2 0-.3-.1v-.4zm.2 0v.3c0 .1.1.1.2.1s.2 0 .2-.1c.1-.1.1-.2.1-.3v-.3c0-.1-.1-.1-.2-.1s-.2 0-.2.1-.1.2-.1.3zm1.2 1l.3-1.4h.1v.1l.1-.1h.2c.1 0 .2 0 .2.1 0 0 .1.1.1.2v.3c0 .1-.1.2-.1.3 0 .1-.1.1-.2.2-.1 0-.1.1-.2 0h-.1l-.1-.1-.1.5-.2-.1zm.4-.9v.3c0 .1.1.1.2.1s.1 0 .2-.1.1-.2.1-.3v-.3c0-.1-.1-.1-.2-.1s-.1 0-.2.1c0 .1-.1.2-.1.3zm.8.5l.2-1h.1v.2c0-.1.1-.1.1-.1h.1c.1 0 .1 0 .2.1l-.1.2h-.2l-.1.1c0 .1 0 .1-.1.2l-.1.5h-.1v-.2zm.6-.4c0-.2.1-.3.2-.4.1-.1.2-.1.3-.1.1 0 .2 0 .3.1.1.1.1.2 0 .4 0 .1-.1.2-.1.3 0 .1-.1.1-.2.2h-.3c-.1 0-.2-.1-.3-.2.1 0 .1-.1.1-.3zm.2 0v.3c0 .1.1.1.2.1s.2 0 .2-.1c.1-.1.1-.1.1-.3v-.3c0-.1-.1-.1-.2-.1s-.2 0-.2.1-.1.2-.1.3zm1-.6v-.2h.2v.2h-.2zm-.5 1.5l.1-.1h.1s0-.1.1-.2l.2-1h.2l-.2 1c0 .1-.1.2-.1.3 0 .1-.1.1-.2.1s-.2 0-.2-.1zm1.4-.6h.2c0 .1-.1.2-.2.2-.1.1-.2.1-.3.1-.1 0-.2-.1-.3-.2-.1-.1-.1-.2 0-.4 0-.2.1-.3.2-.4.1-.1.2-.1.4-.1.1 0 .2 0 .3.1.1.1.1.2 0 .4h-.7v.3c0 .1.1.1.2.1h.2c-.1 0 0 0 0-.1zm-.4-.3h.5v-.2c0-.1-.1-.1-.2-.1s-.1 0-.2.1-.1.1-.1.2zM198.2 281.7h.2c0 .1-.1.2-.2.3-.1.1-.2.1-.3.1-.1 0-.2-.1-.3-.2-.1-.1-.1-.2 0-.4 0-.1.1-.2.1-.3 0-.1.1-.1.2-.2h.2c.1 0 .2 0 .2.1s.1.1.1.2h-.2v-.2l-.1-.1c-.1 0-.2 0-.2.1-.1.1-.1.2-.1.3v.3c0 .1.1.1.2.1h.2c-.1.1 0 0 0-.1zm.6.3v.2H198.5l-.1-.1v-.2l.1-.6h-.1v-.1h.1v-.3l.2-.1-.1.3h.2v.1h-.2l-.1.6v.1c.2.1.2.1.3.1-.1 0 0 0 0 0zm.2-.3c0-.2.1-.3.2-.4.1-.1.2-.1.3-.1.1 0 .2.1.3.2.1.1.1.2 0 .4 0 .1-.1.2-.1.3l-.2.2c-.1 0-.2.1-.2 0-.1 0-.2-.1-.3-.2v-.4zm.2 0v.3c0 .1.1.1.2.1s.2 0 .2-.1c.1-.1.1-.2.1-.3v-.3c0-.1-.1-.1-.2-.1s-.2 0-.2.1c-.1.1-.1.2-.1.3zm1.9.7v-.1c-.1.1-.2.1-.3.1-.1 0-.1 0-.2-.1-.1 0-.1-.1-.1-.2v-.3c0-.1.1-.2.1-.3 0-.1.1-.1.2-.2H201.1l.1.1.1-.5h.2l-.3 1.4-.1.1zm-.4-.6v.3c0 .1.1.1.2.1s.1 0 .2-.1.1-.1.1-.3v-.3c0-.1-.1-.1-.2-.1s-.1 0-.2.1c0 .1-.1.2-.1.3zm1.5.4h.2c-.1.1-.1.2-.2.2s-.2.1-.3 0c-.1 0-.2-.1-.3-.2-.1-.1-.1-.2 0-.4 0-.2.1-.3.2-.4.1-.1.2-.1.3-.1.1 0 .2.1.3.2.1.1.1.2 0 .4l-.7-.1v.3c0 .1.1.1.2.1h.2c0 .1.1 0 .1 0zm-.4-.4h.5v-.2c0-.1-.1-.1-.2-.1s-.1 0-.2.1-.1.1-.1.2zm2.3.4l.2.1c-.1.1-.2.3-.3.3-.1.1-.2.1-.4.1-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.3v-.4c0-.1.1-.3.2-.4.1-.1.2-.2.3-.2.1 0 .2-.1.3-.1.1 0 .2.1.3.1.1.1.1.2.1.3h-.2c0-.1 0-.2-.1-.2 0-.1-.1-.1-.2-.1h-.3c-.1 0-.1.1-.2.2 0 .1-.1.2-.1.3v.3c0 .1 0 .2.1.2s.1.1.2.1.2 0 .3-.1c.1.1.1 0 .2-.1zm.3 0c0-.2.1-.3.3-.4.1-.1.2-.1.3-.1.1 0 .2.1.3.2s.1.2 0 .4c0 .1-.1.2-.1.3 0 .1-.1.1-.2.1h-.2c-.1 0-.2-.1-.3-.2-.1 0-.2-.1-.1-.3zm.2 0v.3c0 .1.1.1.2.1s.2 0 .2-.1c.1 0 .1-.1.2-.3v-.3c0-.1-.1-.1-.2-.1s-.2 0-.2.1c-.2.1-.2.2-.2.3zm.7.6l.4-1.4h.2l-.4 1.4h-.2zm1.1.1v-.1c-.1.1-.2.1-.3.1h-.2l-.1-.1v-.1-.2l.2-.6h.2l-.2.6V282.8h.2c.1 0 .1 0 .1-.1 0 0 .1-.1.1-.2l.1-.5h.2l-.3 1v-.1zm.3.1l.3-1h.1v.1l.1-.1h.2c.1 0 .1 0 .2.1 0 0 0 .1.1.1.1-.1.2-.2.3-.1.1 0 .2 0 .2.1v.3l-.2.7h-.2l.2-.6v-.2-.1h-.2s-.1.1-.1.2l-.2.6h-.2l.2-.6v-.2l-.1-.1h-.1l-.1.1s-.1.1-.1.2l-.1.5h-.3zm1.7.2h-.1l.4-1.4h.2l-.1.5c.1-.1.2-.1.3-.1.1 0 .1 0 .2.1l.1.1v.4c-.1.2-.1.3-.2.4-.1.1-.2.1-.3.1-.1 0-.2-.1-.2-.2l-.3.1zm.1-.5v.3c0 .1.1.1.2.2.1 0 .1 0 .2-.1s.1-.1.2-.3v-.3c0-.1-.1-.1-.1-.1-.1 0-.1 0-.2.1-.2 0-.2.1-.3.2zm1.4.6c-.1 0-.1.1-.2.1h-.2c-.1 0-.2-.1-.2-.1 0-.1-.1-.1 0-.2 0 0 0-.1.1-.1l.1-.1h.5v-.2s-.1-.1-.2-.1h-.2l-.1.1h-.2c0-.1.1-.1.1-.2 0 0 .1-.1.2-.1h.2c.1 0 .1 0 .2.1l.1.1V282.9l-.1.2c0 .2-.1.3-.1.3v.1h-.2c.2-.1.2-.2.2-.2zm.1-.4h-.4-.1v.2l.1.1h.2c.1 0 .1 0 .1-.1 0 0 .1-.1.1-.2zm.3.6l.3-1h.1v.1c.1-.1.2-.1.3-.1h.1l.1.1V282.9l-.2.6h-.2l.2-.6v-.2-.1H210.7c-.1 0-.1.1-.2.2l-.2.5v.2zm1-.4c0-.2.1-.3.3-.4.1-.1.2-.1.3-.1.1 0 .2.1.3.2 0 .1.1.2 0 .4 0 .1-.1.2-.1.3-.1.1-.1.1-.2.1h-.2c-.1 0-.2-.1-.3-.2-.1 0-.1-.1-.1-.3zm.2.1v.3c0 .1.1.1.2.1s.1 0 .2-.1.1-.1.2-.3v-.3c0-.1-.1-.1-.2-.1s-.2 0-.2.1c-.1 0-.2.1-.2.3z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st0",
  d: "M215.3 288h-.2c-.2-.1-.2-.3-.1-.5l4-7.2c.1-.2.3-.2.5-.1s.2.3.1.5l-4 7.2s-.2.1-.3.1z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M117.1 214.6c22.7-.3 127.5 64.1 127.8 76l-6.5 10c-2.9-13.8-109.3-76.4-126.8-75.3l5.5-10.7z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M239.1 300l5.1-8.8c.1-.1.2-.1.3-.1.1.1.1.2.1.3l-5.5 8.6zM112 224.7l4.7-9.7c.1-.1.2-.1.3-.1.1.1.1.2.1.3l-5.1 9.5z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M110.9 224.9c4.2-2.9 35.2 10.9 67.6 30.5 32.3 19.6 63.2 41.8 60.4 45.9l-.9 1.4-.4.3c.1-.1.6-.6 0-2.2-1.4-4.5-23.3-22-59.6-44-35.4-21.1-64.9-33.9-67.9-30.2l.8-1.7zm134.6 66.4c2.7-5.3-26.1-26.9-61.6-48-36.4-20.7-62.7-32.8-67.5-29.2l-1.1 1.9c0 .1 0-.1.3-.3.9-.8 2.3-.7 3-.7 8.3.1 31.8 11 64.9 30 14.5 8.5 61.2 38.4 61.1 46.9 0 .7.1.9-.2 1.2l1.1-1.8z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M237.7 303.2l-.2-.3c-.1 0-.1 0-.1-.1 0 0 .5-.5-.1-1.9-1.4-4.7-24.6-22.7-59.5-43.9-29.9-17.9-57.6-30.8-65.8-30.8-.9 0-1.6.2-1.9.5v-.1c0-.1 0-.2.1-.3l.5-1.6c.5-.4 1.1-.5 1.9-.5 8.3 0 37.2 13.6 65.9 30.9 29.1 17.7 59.3 38.8 60.6 45 .1.5.1.9-.2 1.2l-.9 1.4s-.2.1-.3.2c.1.2 0 .3 0 .3zM112 225.8c8.2 0 36 13 66 30.9 35.5 21.5 58.2 39.3 59.7 44.1.2.6.3 1.1.3 1.4l.7-1.1c.2-.2.2-.5.1-.9-1.3-6.1-32.1-27.6-60.4-44.7-28.6-17.3-57.5-30.8-65.7-30.8-.7 0-1.3.1-1.6.3l-.6 1.1c.3-.2.8-.3 1.5-.3zm132.5 67.3h-.1l-.1-.3-.1.2.1-.2c.1-.1.1-.3.1-.7.2-8.7-47.5-39.1-61-47-33-18.9-56.6-29.8-64.8-29.9-.8 0-2.1 0-2.8.7.8-1.1 2-1.1 2.7-1.1 8.5.1 32.2 11 65.2 30 9.5 5.6 61.4 37.9 61.2 47.1v.2l.6-.9c2.5-4.8-24.6-25.8-61.6-47.7-39.1-22.2-62.9-32.4-67.2-29.2l-.9 1.6c-.2.1-.5.2-.5.1l1.1-2c.7-.5 1.6-.7 2.8-.7 10.2 0 41 16.2 65 29.9 32.1 19 64.7 42.4 61.7 48.3l-1.1 1.6h-.3z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st5",
  d: "M134.7 264.2c0 12.1 5 23.1 13 31.2 8.1 8 19 13.1 31.2 13.1s23.3-5 31.4-13c8-8 13-19.1 13-31.3v-59.1l-88.6-.1v59.2z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M179 308.8c-11.7 0-22.8-4.7-31.4-13.2-8.5-8.4-13.1-19.6-13.1-31.4V205l88.9-.1.3 59.4c0 11.9-4.7 23-13.1 31.4-8.5 8.4-19.7 13.1-31.6 13.1zm44.1-103.7l-88.3.1.3 59c0 11.7 4.6 22.7 13 31 8.4 8.4 19.5 13 31 13 11.8 0 22.8-4.6 31.2-12.9 8.3-8.3 12.9-19.4 12.9-31.1v-59.1h-.1z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st0",
  d: "M136.4 264.3c0 11.7 4.8 22.2 12.5 29.9 7.7 7.7 18.4 12.5 30 12.5 11.7 0 22.3-4.7 30-12.4 7.7-7.7 12.5-18.2 12.5-29.9V207h-84.9l-.1 57.3zm67.9-40.1v40.4c0 1-.1 2.2-.2 3.2-.7 5.8-3.3 10.8-7.3 14.7-4.6 4.6-10.9 7.4-17.9 7.4-7 0-13.2-2.9-17.8-7.5-4.7-4.7-7.5-11.2-7.5-17.9v-40.3h50.7z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M178.9 306.9c-11.3 0-22-4.5-30.1-12.5-8.1-8.1-12.6-18.7-12.6-30v-57.3l85.1-.2.2 57.6c0 11.3-4.4 22-12.5 30-8 8-18.7 12.4-30.1 12.4zm42.3-99.9l-84.8.2.1 57.1c0 11.2 4.4 21.8 12.5 29.8 8 8 18.7 12.4 29.9 12.4 11.3 0 21.9-4.4 29.9-12.4s12.4-18.5 12.4-29.8V207zm-42.3 83c-6.6 0-13-2.7-17.9-7.6-4.8-4.8-7.5-11.4-7.5-18v-40.5l50.9.1.2 36.7v3.9c0 1-.1 2.2-.2 3.2-.7 5.6-3.2 10.7-7.3 14.8-5 4.8-11.4 7.4-18.2 7.4zm-25.1-65.7v40.1c0 6.6 2.7 13 7.4 17.8 4.9 4.8 11.1 7.5 17.6 7.5 6.7 0 13-2.6 17.8-7.4 4.1-4.1 6.6-9.1 7.2-14.6.1-1 .2-2.1.2-3.1v-40.4l-50.2.1z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st6",
  d: "M173.6 257.8c0 1.7.6 3.2 1.6 4.3 1 1.1 2.4 1.8 4 1.8 1.5 0 2.9-.7 4-1.8 1-1.1 1.6-2.6 1.6-4.3v-8h-11.2v8z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st5",
  d: "M182.3 251.7c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1.1-.6-.5-1.1-1.1-1.1zM179.2 254.7c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM182.3 257.8c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM176.3 257.8c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM176.3 251.7c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st6",
  d: "M173.5 277.1c0 1.7.6 3.2 1.7 4.3 1 1.1 2.4 1.8 4 1.8 1.5 0 2.9-.7 4-1.8 1-1.1 1.6-2.6 1.6-4.2v-8h-11.2l-.1 7.9z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st5",
  d: "M182.3 271c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM179.2 274c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1c0-.7-.5-1.1-1.1-1.1zM182.3 277.1c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1zM176.2 277.1c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM176.2 271c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st6",
  d: "M158.1 257.8c0 1.6.6 3.2 1.6 4.2 1 1.1 2.4 1.8 4 1.8s2.9-.7 4-1.8c1-1.1 1.6-2.6 1.6-4.2v-8h-11.2v8z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st5",
  d: "M166.8 251.8c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.7-.5-1.1-1.1-1.1zM163.7 254.7c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1zM166.8 257.9c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.7-.5-1.1-1.1-1.1zM160.8 257.9c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM160.7 251.7c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1.1-.6-.4-1.1-1.1-1.1z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st6",
  d: "M189.1 257.8c0 1.7.6 3.2 1.6 4.3 1 1.1 2.4 1.8 4 1.8s2.9-.7 4-1.8c1-1.1 1.6-2.6 1.6-4.2v-8h-11.2v7.9z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st5",
  d: "M197.8 251.7c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM194.7 254.7c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM197.8 257.8c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM191.8 257.9c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.7-.5-1.1-1.1-1.1zM191.7 251.7c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1c.1-.6-.4-1.1-1.1-1.1z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st6",
  d: "M173.6 238.4c0 1.6.6 3.1 1.6 4.2s2.4 1.8 4 1.8 2.9-.7 4-1.8c1-1.1 1.6-2.6 1.6-4.3v-8h-11.2v8.1z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st5",
  d: "M182.3 232.3c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM179.2 235.3c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1zM182.3 238.4c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM176.3 238.4c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM176.3 232.3c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M141.9 222c.1-4.1 3-5.1 3-5.1s3.2 1 3.1 5.1h-6.1z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M139.4 216.9l-.5 4.7h3.1c0-3.9 3-4.6 3-4.6.1 0 3 .9 3.1 4.6h3.1l-.6-4.8-11.2.1z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M151.3 221.9H148c-.3-3.7-3-4.6-3.1-4.6 0 0-2.8.6-2.8 4.4l-3.3.2.3-4.9 11.4-.2.8 5.1zm-6.6-4.9l-5.3.1-.3 4.6 2.9-.2c-.2-3.2 1.8-4.2 2.7-4.5zm.5 0c.8.3 2.9 1.4 3 4.7l2.7-.2-.5-4.6-5.2.1z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M138.7 221.7h12.6c.3 0 .5.3.5.6s-.2.6-.5.6h-12.6c-.3 0-.5-.3-.5-.6s.2-.6.5-.6z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M151.3 223.1h-12.6c-.4 0-.7-.3-.7-.8 0-.4.3-.8.7-.8h12.6c.4 0 .7.3.7.8 0 .4-.3.8-.7.8zm-12.6-1.2v.8h12.6c.2 0 .3-.2.3-.4l-12.9-.4z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M143.3 221.7c0-2.5 1.7-3.2 1.7-3.2s1.8.7 1.8 3.2h-3.5z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M146.9 221.9h-3.6c-.2-2.8 1.5-3.5 1.6-3.5.2 0 2 .8 2 3.3v.2zm-2-3.2c.1 0-1.4.7-1.4 3l3.1-.2c-.2-2.1-1.7-2.8-1.7-2.8z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M138.9 215H151c.3 0 .5.2.5.5s-.2.5-.5.5h-12.1c-.3 0-.5-.2-.5-.5.1-.3.3-.5.5-.5z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M151.1 216.2H139c-.4 0-.6-.3-.6-.7 0-.4.3-.7.6-.7h12.1c.4 0 .6.3.6.7 0 .4-.3.7-.6.7zm-12.2-1v.7H151c.1 0 .3-.2.3-.3l-12.4-.4z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M139.2 216h11.6c.2 0 .4.2.4.5s-.2.5-.4.5h-11.6c-.3 0-.4-.2-.4-.5-.1-.2.1-.5.4-.5z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M150.8 217.3h-11.6c-.4 0-.6-.3-.6-.7 0-.4.3-.7.6-.7h11.6c.3 0 .6.3.6.7 0 .3-.3.7-.6.7zm-11.6-1.1v.7h11.6c.1 0 .3-.2.3-.3l-11.9-.4z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M142.9 208.1h.9v.6h.7v-.7h.9v.7h.7v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.3c-.2 0-.4-.2-.4-.4v-1.4z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M146.7 210.2h-3.5l-.4-.6v-1.5l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.6.6zm-3-2.1l-.7.2.2 1.3 3.5.4.2-.4v-1.5l-.8.2.2.5-.9.2-.2-.8-.8.2.2.5-.8.2-.1-1z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M146.4 210.1l.2 4.9-3.2-.1.2-4.8h2.8z"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M146.8 215.1h-3.4v-5l3-.2.4 5.2zm-.6-5l-2.6.2v4.6l2.8-.2-.2-4.6z"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M146.9 210.5h.9v.6h.6v-.7h.9v.7h.6v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.2c-.2 0-.4-.2-.4-.4v-1.4h.1z"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M150.6 212.5h-3.4l-.4-.6v-1.5l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.7.6zm-3-2l-.7.2.2 1.3 3.4.4.2-.4v-1.5l-.7.2.2.5-.8.2-.2-.8-.7.2.2.5-.8.2-.3-1z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M150.4 212.4l.1 2.6h-3.1l.1-2.6z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M150.7 215.1h-3.3l-.1-2.8 3.1-.2.3 3zm-.5-2.7l-2.7.2.1 2.4 2.7-.2-.1-2.4z"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M139 210.5h.9v.7h.6v-.7h.9v.7h.7v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.2c-.2 0-.4-.2-.4-.4v-1.5z"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M142.6 212.6h-3.4l-.4-.6v-1.5l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.7.6zm-2.9-2.1l-.7.2.2 1.3 3.5.4.2-.4v-1.5l-.7.2.2.5-.8.2-.2-.8-.7.2.2.5-.8.2-.4-1z"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M142.5 212.4l.1 2.6h-3.1l.1-2.6z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M142.7 215.2h-3.3l-.1-2.8 3.1-.2.3 3zm-.4-2.8l-2.7.2.1 2.4 2.7-.2-.1-2.4zM144.7 211.7c0-.5.6-.5.6 0v1.1h-.6v-1.1zM148.6 213.3c0-.5.6-.5.6 0v.9h-.6v-.9z"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M140.7 213.3c0-.4.6-.5.6 0v.9h-.6v-.9z"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M177 208.1h.9v.7h.7v-.7h.9v.7h.7v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.3c-.2 0-.4-.2-.4-.4v-1.5z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M180.8 210.2h-3.5l-.4-.6v-1.5l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.9.5-.2-.2-.5 1.1-.2.2 1.9-.6.5zm-3-2.1l-.7.2.2 1.3 3.5.4.2-.4v-1.5l-.8.2.2.5-.9.2-.2-.9-.8.2.2.5-.7.2-.2-.9z"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M180.5 210.1l.2 4.9-3.2-.1.2-4.8h2.8z"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M180.9 215.1h-3.4v-5l3-.2.4 5.2zm-.6-4.9l-2.6.2v4.6l2.8-.2-.2-4.6z"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M181 210.5h.9v.6h.7v-.7h.9v.7h.6v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.2c-.2 0-.4-.2-.4-.4v-1.4z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M184.7 212.5h-3.4l-.4-.6v-1.5l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.9.5-.2-.2-.5 1.1-.2.2 1.9-.7.5zm-3-2l-.7.2.2 1.3 3.4.4.2-.4v-1.5l-.7.2.2.5-.8.2-.2-.9-.7.2.2.5-.8.2-.3-.9z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M184.5 212.4l.1 2.6h-3.1l.1-2.6z"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M181.3 215.2l.1-2.8 3.1-.2.3 2.8-3.5.2zm3-2.8l-2.7.2.1 2.2h2.9l-.3-2.4z"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M173.1 210.5h.9v.6h.6v-.7h.9v.7h.6v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.2c-.2 0-.4-.2-.4-.4v-1.4h.1z"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M176.7 212.6h-3.4l-.4-.6v-1.5l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.7.6zm-2.9-2.1l-.7.2.2 1.3 3.5.4.2-.4v-1.5l-.7.2.2.5-.8.2-.2-.8-.7.2.2.5-.8.2-.4-1z"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M176.6 212.4l.1 2.6h-3.1l.1-2.6z"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M176.9 215.2h-3.3l-.1-2.8 3.1-.2.3 3zm-.5-2.8l-2.7.2.1 2.4 2.7-.2-.1-2.4z"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M176 222c.1-4.1 3-5.1 3-5.1s3.2 1.1 3.1 5.2l-6.1-.1z"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M173.5 216.9l-.5 4.7h3.1c0-3.9 3-4.6 3-4.6.1 0 3 .9 3.1 4.6h3.1l-.6-4.8-11.2.1z"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M185.5 221.9h-3.3c-.3-3.8-3.1-4.6-3.1-4.6s-2.8.6-2.8 4.4l-3.3.2.3-4.9 11.4-.2.8 5.1zm-6.8-4.9l-5.3.1-.3 4.6 2.9-.2c-.1-3.2 1.9-4.2 2.7-4.5zm.7 0c.8.3 2.9 1.4 3 4.7l2.7-.2-.5-4.6-5.2.1z"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M172.8 221.7h12.6c.3 0 .5.3.5.6s-.2.6-.5.6h-12.6c-.3 0-.5-.3-.5-.6s.2-.6.5-.6z"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M185.4 223.1h-12.6c-.4 0-.7-.3-.7-.8 0-.4.3-.8.7-.8h12.6c.4 0 .7.3.7.8 0 .4-.3.8-.7.8zm-12.6-1.2v.8h12.6c.2 0 .3-.2.3-.4l-12.9-.4z"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M177.4 221.7c0-2.5 1.7-3.2 1.7-3.2s1.8.7 1.8 3.2h-3.5z"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M181 221.9h-3.6c-.2-2.8 1.5-3.5 1.6-3.5.2 0 2 .8 2 3.3v.2zm-2-3.2c.1 0-1.4.7-1.4 3l3.1-.2c-.2-2.1-1.7-2.8-1.7-2.8z"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M173 215h12.1c.3 0 .5.2.5.5s-.2.5-.5.5H173c-.3 0-.5-.2-.5-.5.1-.3.3-.5.5-.5z"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M185.2 216.2H173c-.4 0-.6-.3-.6-.7 0-.4.3-.7.6-.7h12.1c.4 0 .6.3.6.7.1.4-.2.7-.5.7zm-12.2-1v.7h12.1c.1 0 .3-.2.3-.3l-12.4-.4z"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M173.3 216h11.6c.3 0 .4.2.4.5s-.2.5-.4.5h-11.6c-.3 0-.4-.2-.4-.5 0-.2.1-.5.4-.5z"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M184.9 217.3h-11.6c-.4 0-.6-.3-.6-.7 0-.4.3-.7.6-.7h11.6c.3 0 .6.3.6.7 0 .4-.3.7-.6.7zm-11.6-1.1v.7h11.6c.1 0 .3-.2.3-.3l-11.9-.4zM178.8 211.7c0-.5.6-.5.6 0v1.2h-.6v-1.2zM182.7 213.3c0-.4.6-.5.6 0v.9h-.6v-.9zM174.8 213.3c0-.5.6-.5.6 0v.9h-.6v-.9z"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M210.8 208.1h.9v.6h.7v-.7h.9v.7h.7v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.3c-.2 0-.4-.2-.4-.4v-1.4z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M214.5 210.2H211l-.4-.6v-1.5l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.6.6zm-3-2.1l-.7.2.2 1.3 3.5.4.2-.4v-1.5l-.8.2.2.5-.8.2-.2-.8-.8.2.2.5-.9.2-.1-1z"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M214.2 210.2l.2 4.8h-3.2l.2-4.8z"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M214.6 215.2h-3.4v-5l3-.2.4 5.2zm-.6-5l-2.6.2v4.6l2.8-.2-.2-4.6z"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M214.7 210.5h.9v.6h.6v-.7h.9v.7h.7v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.2c-.2 0-.4-.2-.4-.4v-1.4z"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M218.4 212.6H215l-.4-.6v-1.5l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.7.6zm-2.9-2.1l-.7.2.2 1.3 3.5.4.2-.4v-1.5l-.7.2.2.5-.8.2-.2-.8-.7.2.2.5-.8.2-.4-1z"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M218.2 212.4l.1 2.6h-3.1l.1-2.6z"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M218.5 215.2h-3.3l-.1-2.8 3.1-.2.3 3zm-.5-2.8l-2.7.2.1 2.4 2.7-.2-.1-2.4z"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M206.8 210.5h.9v.6h.7v-.7h.9v.7h.7v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.2c-.2 0-.4-.2-.4-.4v-1.4h-.1z"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M210.5 212.6h-3.4l-.4-.6v-1.5l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.7.6zm-3-2.1l-.7.2.2 1.3 3.5.4.2-.4v-1.5l-.7.2.2.5-.8.2-.2-.8-.7.2.2.5-.8.2-.4-1z"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M210.3 212.4l.1 2.6h-3.1l.1-2.6z"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M210.6 215.2h-3.3l-.1-2.8 3.1-.2.3 3zm-.5-2.8l-2.7.2.1 2.4 2.7-.2-.1-2.4z"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M209.7 222c.1-4.1 3-5.1 3.1-5.1 0 0 3.2 1.1 3.1 5.2l-6.2-.1z"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M207.2 217l-.5 4.7h3.1c0-3.9 3-4.6 3-4.6.1 0 3 .9 3.1 4.6h3.1l-.6-4.8-11.2.1z"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M219.2 221.9h-3.3c-.3-3.7-3.1-4.6-3.1-4.6s-2.8.6-2.8 4.4l-3.3.2.3-4.9 11.4-.2.8 5.1zm-6.7-4.8l-5.3.1-.3 4.6 2.9-.2c-.1-3.3 1.9-4.3 2.7-4.5zm.6-.1c.8.3 2.9 1.4 3 4.7l2.7-.2-.5-4.6-5.2.1z"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M206.5 221.7h12.6c.3 0 .5.3.5.6s-.2.6-.5.6h-12.6c-.3 0-.5-.3-.5-.6s.2-.6.5-.6z"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M219.1 223.1h-12.6c-.4 0-.7-.3-.7-.8s.3-.8.7-.8h12.6c.4 0 .7.3.7.8s-.3.8-.7.8zm-12.6-1.2v.8h12.6c.2 0 .3-.2.3-.4l-12.9-.4z"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M211.1 221.7c0-2.5 1.7-3.2 1.7-3.2s1.8.7 1.8 3.2h-3.5z"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M214.7 221.9h-3.6c-.2-2.7 1.6-3.5 1.6-3.5.2 0 2 .8 2 3.3v.2zm-2-3.2c.1 0-1.4.7-1.4 3l3.1-.2c-.1-2.1-1.6-2.8-1.7-2.8z"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M206.8 215h12.1c.3 0 .5.2.5.5s-.2.5-.5.5h-12.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M218.9 216.2h-12.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h12.1c.4 0 .7.3.7.7-.1.4-.4.7-.7.7zm-12.1-1v.7h12.1c.2 0 .3-.2.3-.3l-12.4-.4z"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M207 216.1h11.6c.2 0 .4.2.4.5s-.2.5-.4.5H207c-.2 0-.4-.2-.4-.5s.2-.5.4-.5z"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M218.6 217.3H207c-.3 0-.6-.3-.6-.7 0-.4.3-.7.6-.7h11.6c.3 0 .6.3.6.7 0 .4-.2.7-.6.7zm-11.6-1.1v.7h11.6c.1 0 .3-.2.3-.3l-11.9-.4zM212.5 211.7c0-.5.7-.5.6 0v1.2h-.6v-1.2zM216.5 213.3c0-.5.6-.5.6 0v.9h-.6v-.9zM208.5 213.4c0-.5.6-.5.6 0v.9h-.6v-.9z"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M143 242.7h.9v.7h.7v-.7h.9v.7h.7v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.3c-.2 0-.4-.2-.4-.4v-1.5z"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M146.7 244.7h-3.5l-.4-.6v-1.5l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.8-.6.7zm-3-2l-.7.2.2 1.3 3.5.4.2-.4v-1.5l-.8.2.2.5-.8.2-.2-.8-.8.2.2.5-.8.2-.2-1z"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M146.4 244.7l.2 4.8h-3.2l.2-4.8h2.8z"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M146.8 249.7h-3.4v-5l3-.2.4 5.2zm-.6-5l-2.6.2v4.6l2.8-.2-.2-4.6z"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M146.9 245.1h.9v.6h.6v-.7h.9v.7h.7v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.2c-.2 0-.4-.2-.4-.4v-1.4z"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M150.6 247.1h-3.4l-.4-.6V245l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.7.6zm-2.9-2l-.7.2.2 1.3 3.5.4.2-.4V245l-.7.2.2.5-.8.2-.2-.8-.7.2.2.5-.8.2-.4-.9z"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M150.4 246.9l.1 2.6h-3.1l.1-2.6z"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M150.7 249.7h-3.3l-.1-2.8 3.1-.2.3 3zm-.5-2.8l-2.7.2.1 2.4 2.7-.2-.1-2.4z"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M139 245.1h.9v.6h.7v-.7h.9v.7h.6v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.2c-.2 0-.4-.2-.4-.4v-1.4z"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M142.7 247.1h-3.4l-.4-.6V245l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.7.6zm-3-2l-.7.2.2 1.3 3.5.4.2-.4v-1.5l-.7.2.2.5-.8.2-.2-.8-.7.2.2.5-.8.2-.4-1z"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M142.5 246.9l.1 2.6h-3.1l.1-2.6z"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M142.8 249.7h-3.3l-.1-2.8 3.1-.2.3 3zm-.5-2.7l-2.7.2.1 2.4 2.7-.2-.1-2.4z"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M141.9 256.6c.1-4.1 3-5.1 3-5.1s3.2 1.1 3.1 5.2l-6.1-.1z"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M139.4 251.5l-.5 4.7h3.1c0-3.9 3-4.6 3-4.6.1 0 3 .9 3.1 4.6h3.1l-.6-4.8-11.2.1z"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M151.4 256.5h-3.3c-.3-3.8-3.1-4.6-3.1-4.6s-2.8.6-2.8 4.4l-3.3.2.3-5 11.4-.2.8 5.2zm-6.7-4.9l-5.3.1-.3 4.6 2.9-.2c-.1-3.2 1.9-4.2 2.7-4.5zm.6 0c.7.3 2.9 1.4 3 4.7l2.7-.2-.5-4.6-5.2.1z"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M138.7 256.3h12.6c.3 0 .5.3.5.6s-.2.6-.5.6h-12.6c-.3 0-.5-.3-.5-.6s.2-.6.5-.6z"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M151.3 257.6h-12.6c-.4 0-.7-.3-.7-.8 0-.4.3-.8.7-.8h12.6c.4 0 .7.3.7.8s-.3.8-.7.8zm-12.6-1.1v.8h12.6c.2 0 .3-.2.3-.4l-12.9-.4z"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M143.3 256.3c0-2.5 1.7-3.2 1.7-3.2s1.8.7 1.8 3.2h-3.5z"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M146.9 256.4h-3.6c-.2-2.7 1.5-3.5 1.7-3.5.1 0 1.9.8 1.9 3.4v.1zm-2-3.1s-1.4.7-1.4 3l3.1-.2c-.1-2.1-1.6-2.8-1.7-2.8z"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M138.9 249.6H151c.3 0 .5.2.5.5s-.2.5-.5.5h-12.1c-.3 0-.5-.2-.5-.5.1-.3.3-.5.5-.5z"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M151.1 250.8H139c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h12.1c.4 0 .7.3.7.7-.1.4-.4.7-.7.7zm-12.2-1.1v.7H151c.2 0 .3-.2.3-.3l-12.4-.4z"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M139.2 250.6h11.6c.3 0 .5.2.5.5s-.2.5-.5.5h-11.6c-.2 0-.4-.2-.4-.5s.2-.5.4-.5z"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M150.8 251.8h-11.6c-.3 0-.6-.3-.6-.7 0-.4.3-.7.6-.7h11.6c.4 0 .6.3.6.7 0 .4-.3.7-.6.7zm-11.6-1v.7h11.6c.1 0 .3-.2.3-.3l-11.9-.4zM144.7 246.2c0-.5.6-.5.6 0v1.1h-.6v-1.1zM148.7 247.9c0-.5.6-.5.6 0v.9h-.6v-.9zM140.7 247.9c0-.5.6-.5.6 0v.9h-.6v-.9z"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M208.8 279.2l.6.6-.5.5.5.5.5-.5.7.7-.5.5.5.5.5-.5.7.7-1.1 1.1c-.2.2-.4.1-.6 0l-2.3-2.3c-.2-.2-.2-.4 0-.6l1-1.2z"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M210.4 283.5l-.4-.2-2.5-2.5.1-.7 1.1-1.1.9.6-.5.7.5.2.2-.5.9.7-.5.7.5.2.2-.5.9.7-1.4 1.7zm-1.7-4.2l-.8 1 2.5 2.9.1-.2 1.1-1.1-.7-.4-.2.5-.7-.5.5-.7-.7-.4-.2.5-.7-.5.5-.7-.7-.4z"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M209.8 283.1l-3.3 3.5-2.2-2.3 3.5-3.2z"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M206.5 286.9l-2.4-2.4 3.6-3.5 2.2 2-3.4 3.9zm1.2-5.7l-3.3 3.3 2.1 1.9 3.1-3.4-1.9-1.8z"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M209.9 283.7l.6.6-.5.5.5.5.5-.5.6.6-.5.5.5.5.5-.5.6.6-1.1 1.1c-.2.2-.4.1-.6 0l-2.3-2.3c-.2-.2-.2-.4 0-.6l1.2-1z"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M211.5 287.9l-.4-.2-2.4-2.4.1-.7 1.1-1.1.9.6-.5.7.5.2.2-.5.9.6-.5.7.5.2.2-.5.9.6-1.5 1.8zm-1.7-4.1l-.8 1 2.5 2.8.1-.2 1.1-1.1-.7-.3-.2.5-.7-.5.5-.7-.6-.4-.2.5-.7-.5.5-.7-.8-.4z"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M211.1 287.5l-1.8 1.9-2.2-2.2 1.9-1.8 2.1 2.1z"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M209.3 289.6l-2.3-2.3 1.9-2 2.3 2.1-1.9 2.2zm-.4-4.1l-1.6 1.8 2 1.8 1.6-1.8-2-1.8z"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M204.3 278.1l.6.6-.5.5.5.5.5-.5.6.6-.5.5.5.5.5-.5.6.6-1.1 1.1c-.2.2-.4.1-.6 0l-2.3-2.3c-.2-.1-.2-.4 0-.6l1.2-1z"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M205.9 282.3l-.4-.2-2.3-2.4v-.8l1-1.1.9.6-.5.7.5.2.2-.5.9.6-.5.7.5.2.2-.5.9.6-1.4 1.9zm-1.7-4.1l-.8 1.1 2.5 2.8.1-.2 1.1-1.1-.6-.4-.2.5-.7-.5.5-.7-.6-.4-.2.5-.7-.5.5-.7-.9-.4z"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M205.4 281.8l-1.7 2-2.2-2.2 1.9-1.8z"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M203.7 284l-2.3-2.3 1.9-2 2.3 2-1.9 2.3zm-.4-4.1l-1.6 1.8 2 1.8 1.6-1.8-2-1.8z"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M198.3 288.3c3-2.8 5.7-1.5 5.8-1.5 0 0 1.5 3-1.4 5.9l-4.4-4.4z"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M200 282.9l-3.7 3 2.2 2.2c2.8-2.8 5.3-1.1 5.4-1.1 0 0 1.5 2.7-1.1 5.4l2.2 2.2 3-3.8-8-7.9z"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M205 294.9l-2.3-2.3c2.4-2.8 1.1-5.3 1-5.4 0 0-.7-.5-1.8-.5-1.2 0-2.3.5-3.3 1.5l-2.4-2.2 3.7-3.3 8.2 7.9-3.1 4.3zm-.8-7.7c.1.3.3.8.3 1.4.1 1-.1 2.5-1.5 4l2 1.8 2.8-3.6-3.6-3.6zm-4.3-4.2l-3.5 3 2.2 1.9c1.4-1.8 4.1-1.7 5-1.3l-3.7-3.6z"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M196.2 285.8l8.9 8.9c.2.2.2.5-.1.8-.2.2-.6.3-.8.1l-8.9-8.9c-.2-.2-.2-.5.1-.8.2-.3.6-.3.8-.1z"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M204.6 295.9l-.4-.2-8.9-8.9c-.3-.3-.2-.7.1-1l.6-.3 9.4 9.1c.3.3.2.7-.1 1l-.7.3zm-9.1-9.4l9.1 9.2.3-.3-8.9-9.4-.7.7.2-.2z"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M199.4 289c1.8-1.7 3.4-1 3.5-1 0 0 .7 1.7-1 3.5l-2.5-2.5z"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M201.9 291.7l-2.6-2.6c1.9-2.4 3.6-1.4 3.6-1.3.2.2.8 2-.9 3.8l-.1.1zm.1-3.7c-.6 0-1.5.2-2.4 1.1l2.3 2.1c1.4-1.5.9-2.9.8-3.1 0 0-.3-.1-.7-.1z"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M201.1 281.2l8.6 8.6c.2.2.2.5 0 .7-.2.2-.5.2-.7 0l-8.6-8.6c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0z"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M209.3 290.8l-.5-.2-8.6-8.6c-.3-.3-.2-.7 0-1h1l8.6 8.6c.2.2.2.7 0 1l-.5.2zm-8.3-9.5l-.5.5 8.8 8.8.2-.3-8.5-9z"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M200.5 282.1l8.2 8.2c.2.2.1.5-.1.7-.2.2-.5.2-.7 0l-8.2-8.2c-.2-.2-.1-.5.1-.7.3-.1.6-.1.7 0z"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M208.3 291.4l-.4-.2-8.2-8.2c-.2-.2-.2-.7.1-.9l.9-.1 8.2 8.2c.2.2.2.7-.1.9l-.5.3zm-7.9-9.1l-.5.5 8.4 8.5.3-.3-8.2-8.7zM207.5 282.8c.3-.3.8.1.5.5l-.8.8-.5-.5.8-.8zM209.1 286.8c.3-.3.8.1.4.4l-.6.6-.4-.4.6-.6zM203.5 281.2c.3-.3.8.1.4.4l-.6.6-.4-.4.6-.6z"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M210.7 242.7h.9v.6h.7v-.7h.9v.7h.7v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.3c-.2 0-.4-.2-.4-.4v-1.4z"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M214.4 244.8H211l-.4-.6v-1.5l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.7.6zm-3-2.1l-.7.2.2 1.3 3.5.4.2-.4v-1.5l-.8.2.2.5-.9.2-.2-.8-.8.2.2.5-.8.2-.1-1z"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M214.2 244.7l.2 4.8h-3.2l.2-4.8z"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M214.6 249.7h-3.4v-5l3-.2.4 5.2zm-.6-5l-2.6.2v4.6l2.8-.2-.2-4.6z"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M214.7 245.1h.9v.6h.6v-.7h.9v.7h.7v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.2c-.2 0-.4-.2-.4-.4v-1.4z"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M218.3 247.1h-3.4l-.4-.6V245l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.7.6zm-2.9-2l-.7.2.2 1.3 3.5.4.2-.4v-1.5l-.7.2.2.5-.8.2-.2-.8-.7.2.2.5-.8.2-.4-1z"
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M218.2 246.9l.1 2.6h-3.1l.1-2.6z"
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M218.4 249.7h-3.3l-.1-2.8 3.1-.2.3 3zm-.4-2.7l-2.7.2.1 2.4 2.7-.2-.1-2.4z"
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M206.8 245.1h.9v.6h.7v-.7h.9v.7h.7v-.7h.9v1.5c0 .2-.2.4-.4.4h-3.2c-.2 0-.4-.2-.4-.4v-1.4h-.1z"
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M210.4 247.1H207l-.4-.6V245l1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2.8.5-.2-.2-.5 1.1-.2.2 1.9-.7.6zm-2.9-2l-.7.2.2 1.3 3.4.4.2-.4v-1.5l-.7.2.2.5-.8.2-.2-.8-.7.2.2.5-.8.2-.3-1z"
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M210.3 247v2.5l-3 .1.1-2.7z"
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M207.1 249.7l.1-2.8 3.1-.2.3 2.8-3.5.2zm3-2.7l-2.7.2.1 2.2h2.9l-.3-2.4z"
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M209.7 256.6c.1-4.1 3-5.1 3-5.1s3.2 1 3.1 5.1h-6.1z"
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M207.2 251.5l-.5 4.7h3.1c0-3.9 3-4.6 3-4.6.1 0 3 .9 3.1 4.6h3.1l-.6-4.8-11.2.1z"
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M219.1 256.5h-3.3c-.3-3.8-3-4.6-3.1-4.6 0 0-2.8.6-2.8 4.4l-3.3.2.3-4.9 11.4-.2.8 5.1zm-6.7-4.9l-5.3.1-.3 4.6 2.9-.2c-.1-3.2 1.9-4.2 2.7-4.5zm.7 0c.8.3 2.9 1.5 2.9 4.7l2.7-.2-.5-4.6-5.1.1z"
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M206.5 256.3h12.6c.3 0 .5.3.5.6s-.2.6-.5.6h-12.6c-.3 0-.5-.3-.5-.6s.2-.6.5-.6z"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M219.1 257.6h-12.6c-.4 0-.7-.3-.7-.8 0-.4.3-.8.7-.8h12.6c.4 0 .7.3.7.8s-.3.8-.7.8zm-12.6-1.1v.8h12.6c.2 0 .3-.2.3-.4l-12.9-.4z"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M211 256.3c0-2.5 1.7-3.2 1.7-3.2s1.8.7 1.8 3.2H211z"
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M214.7 256.5H211c-.2-2.8 1.6-3.5 1.6-3.5.2 0 2 .8 2 3.3v.2h.1zm-2-3.2c.1 0-1.4.7-1.4 3l3.1-.2c-.2-2.1-1.7-2.8-1.7-2.8z"
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M206.7 249.6h12.1c.3 0 .5.2.5.5s-.2.5-.5.5h-12.1c-.3 0-.5-.2-.5-.5s.3-.5.5-.5z"
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M218.8 250.8h-12.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h12.1c.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm-12.1-1v.7h12.1c.2 0 .3-.2.3-.3l-12.4-.4z"
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M207 250.6h11.6c.2 0 .4.2.4.5s-.2.5-.4.5H207c-.2 0-.4-.2-.4-.5-.1-.2.1-.5.4-.5z"
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M218.6 251.9H207c-.3 0-.6-.3-.6-.7 0-.4.3-.7.6-.7h11.6c.4 0 .6.3.6.7 0 .3-.3.7-.6.7zm-11.6-1.1v.7h11.6c.1 0 .3-.2.3-.3l-11.9-.4zM212.5 246.2c0-.5.6-.5.6 0v1.2h-.6v-1.2zM216.4 247.9c0-.5.6-.5.6 0v.9h-.6v-.9zM208.5 247.9c0-.4.6-.5.6 0v.9h-.6v-.9z"
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M146.3 282.1l.6-.6.5.5.5-.5-.5-.5.7-.7.5.5.5-.5-.5-.5.7-.7 1.1 1.1c.2.2.1.4 0 .6l-2.3 2.3c-.2.2-.4.2-.6 0l-1.2-1z"
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M147.6 283.4l-.4-.2-1-1 .6-.9.7.5.2-.5-.5-.2.7-.9.7.5.2-.5-.5-.2.7-.9 1.5 1.2-.1.7-2.8 2.4zm-.8-1.9l-.4.6 1.2 1 .2-.3 2.3-2.3-1-1.4-.4.7.5.2-.5.7-.7-.5-.4.7.5.2-.5.7-.8-.3z"
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M150.2 281l3.5 3.3-2.3 2.3-3.2-3.6z"
});

var _ref199 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M151.4 286.8l-3.4-3.7 2-2.2 3.8 3.3-2.4 2.6zm-1.4-5.6l-1.7 2 3.1 3.1 2.1-2.1-3.5-3z"
});

var _ref200 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M150.8 280.9l.6-.6.5.5.5-.5-.5-.5.6-.6.5.5.5-.5-.5-.5.7-.6 1.1 1.1c.2.2.1.4 0 .6l-2.3 2.3c-.2.1-.4.2-.6 0l-1.1-1.2z"
});

var _ref201 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M152.1 282.2l-.4-.2-1-1 .6-.9.7.5.2-.5-.5-.2.6-.9.7.5.2-.5-.5-.2.7-.9 1.3 1.2v.7l-2.6 2.4zm-.8-1.8l-.4.6 1.2 1 .2-.3 2.3-2.3-1-1.4-.4.6.5.2-.5.7-.7-.5-.4.6.5.2-.5.7-.8-.1z"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M154.6 279.8l1.9 1.7-2.2 2.2-1.8-1.9z"
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M154.3 284l-1.9-2 2.1-2.3 2.2 1.8-2.4 2.5zm.1-4.1l-1.8 2 1.6 1.5 2-2-1.8-1.5z"
});

var _ref204 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M145.2 286.5l.6-.6.5.5.5-.5-.5-.5.6-.6.5.5.5-.5-.5-.5.6-.6 1.1 1.1c.2.2.1.4 0 .6l-2.3 2.3c-.1.2-.4.2-.6 0l-1-1.2z"
});

var _ref205 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M146.5 287.8l-.4-.2-1.1-1 .6-.9.7.5.2-.5-.5-.2.6-.9.7.5.2-.5-.5-.2.6-.9 1.3 1.1v.7l-2.4 2.5zm-.8-1.8l-.4.6 1.2 1 .2-.3 2.3-2.3-1.1-1.3-.4.6.5.2-.5.7-.7-.5-.4.6.5.2-.5.7-.7-.2z"
});

var _ref206 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M149 285.4l1.9 1.8-2.2 2.1-1.8-1.9z"
});

var _ref207 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M148.7 289.6l-1.9-2 2-2.3 2.2 1.8-2.3 2.5zm.1-4.1l-1.8 2 1.6 1.5 2-2-1.8-1.5z"
});

var _ref208 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M155.4 292.6c-2.8-3-1.5-5.7-1.5-5.8 0 0 3-1.5 5.9 1.4l-4.4 4.4z"
});

var _ref209 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M150 290.8l3 3.7 2.2-2.2c-2.8-2.8-1.1-5.3-1.1-5.4 0 0 2.7-1.5 5.4 1.1l2.2-2.2-3.8-3-7.9 8z"
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M153 294.8l-3.1-3.9 7.9-8.2 4 3-2.2 2.5c-1.3-1-2.4-1.5-3.6-1.5-1.1 0-1.8.4-1.8.4s-1.5 2.4 1.1 5.1l-2.3 2.6zm.8-7.6l-3.6 3.8 2.9 3.3 2-2c-1.6-1.3-1.7-2.8-1.6-3.8 0-.6.1-1.1.3-1.3zm2.2-.9c1.3 0 2.5.5 3.6 1.6l1.9-2.2-3.7-2.7-3.6 3.7c.4-.2 1-.4 1.8-.4z"
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M152.9 294.7l8.9-8.9c.2-.2.5-.2.8.1.2.2.3.6.1.8l-8.9 8.9c-.2.2-.5.2-.7-.1-.4-.3-.4-.6-.2-.8z"
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M153.4 295.8l-.6-.3c-.2-.2-.3-.8-.1-1l8.9-8.9c.7-.2.9-.1 1 .1.2.2.3.8.1 1l-9.3 9.1zm8.7-10l-9.1 9-.1.6.4.2.2-.2 9-9 .1-.6h-.5z"
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M156.1 291.4c-1.7-1.8-1-3.4-1-3.4s1.7-.7 3.5 1l-2.5 2.4z"
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M156.1 291.7l-.1-.1c-1.8-1.8-1.1-3.6-1.1-3.6.2-.2 1.9-.9 3.8.9l-2.6 2.8zm-1-3.6c.1 0-.5 1.4 1 3l2.3-2.3c-1.7-1.2-3.2-.7-3.3-.7z"
});

var _ref215 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M148.3 289.7l8.6-8.6c.2-.2.5-.2.7 0 .2.2.2.5 0 .7l-8.6 8.6c-.2.2-.5.2-.7 0-.2-.2-.2-.5 0-.7z"
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M148.7 290.8l-.5-.3v-.9l8.6-8.6h1c.3.3.3.7 0 1l-9.1 8.8zm0-.4v.2l.2-.3 8.6-8.6.1-.6h-.4l-8.8 8.6-.1.6.4.1z"
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st2",
  d: "M149.2 290.3l8.2-8.2c.2-.2.5-.2.7 0 .2.2.2.5.1.7L150 291c-.2.2-.5.1-.7-.1-.2-.1-.2-.4-.1-.6z"
});

var _ref218 = /*#__PURE__*/React.createElement("path", {
  className: "pt-flag_svg__st3",
  d: "M149.7 291.3l-.5-.2c-.3-.3-.3-.7-.1-.9l8.2-8.2 1 .1c.3.3.3.7.1 1l-8.7 8.2zm0-.3v.2l.2-.2 8.2-8.2.1-.6h-.4l-8.4 8.3-.1.6.4-.1zM150 283.2c-.3-.3.1-.8.5-.5l.8.8-.5.5-.8-.8zM154 281.6c-.3-.3.1-.8.4-.4l.6.6-.4.4-.6-.6zM148.4 287.2c-.3-.3.1-.8.4-.4l.6.6-.4.4-.6-.6z"
});

function SvgPtFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pt-flag_svg__Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218);
}

export default __webpack_public_path__ + "static/pt-flag.54e9dcea.svg";
export { SvgPtFlag as ReactComponent };